/**
 * @file
 * Cart popup scripts.
 */

// Open popup.
const $cartButton = $('.menu-link-item-cart a, .cart-popup-trigger', context);
$cartButton.once('cart-button').each((index, el) => {
  $(el)
    .attr({ 'data-toggle': 'right-off-canvas-menu' })
    .on('click', e => {
      // Prevent default click handler as Zurb's toggler handles it.
      e.preventDefault();
    });
});

// Badge with quantity of items in cart.
const $blockPopup = $('.block-cart-popup', context);

$blockPopup.once('cart-popup-block').each((index, element) => {
  const $items = $(element).find('.views-field-nothing .cart-item').length;

  if ($items) {
    const waitRender = (selector, callback) => {
      if ($(selector).length) {
        callback();
      } else {
        setTimeout(() => waitRender(selector, callback), 100);
      }
    };

    waitRender('.header-nav-commerce .menu-link-item-cart a', () => {
      // Add badge to header icon and to mobile menu icon.
      let quantity = 0;

      if (!$('.js-cart-items').length) {
        $(
          '.header-nav-commerce .menu-link-item-cart a, .cpl-menu-type-7 .menu-icon-cart'
        ).append('<span class="js-cart-items badge alert"></span>');
      }

      $('.block-cart-popup div[class*="form-item-edit-quantity-"]').each(
        (ind, el) => {
          const value = $(el)
            .find('.form-number')
            .val();
          quantity += Number(value);
        }
      );

      if (quantity > 0) {
        $('.js-cart-items').text(quantity);
      }
    });
  } else {
    $('.js-cart-items').remove();
  }
});
